import { ShieldCheck, Gem, Sparkles, RefreshCcw, Scale, Truck } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const PILLARS = [
  { icon: ShieldCheck, label: "100% BIS Hallmarked 916 Gold" },
  { icon: Gem, label: "IGI & SGL Certified Natural Diamonds" },
  { icon: Sparkles, label: "Lifetime Free Cleaning & Maintenance" },
  { icon: RefreshCcw, label: "Best-Value Gold Exchange Policy" },
  { icon: Scale, label: "Complete Transparency in Weight & Stones" },
  { icon: Truck, label: "Complimentary Transit Insurance" },
];

export const TrustBadges = () => (
  <section data-testid="trust-badges-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-12 lg:py-32">
    <SectionHead
      eyebrow="The Aradhana Guarantee"
      title={<>Six pillars. <span className="gold-text italic">Zero compromise.</span></>}
    />
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {PILLARS.map((p, i) => (
        <Reveal key={p.label} delay={i * 0.06}>
          <div
            data-testid={`trust-pillar-${i + 1}`}
            className="group glass-card flex items-center gap-5 rounded-2xl p-6 transition-all duration-500 hover:border-[#D4AF37]/50"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#D4AF37]/30 text-[#D4AF37] transition-all duration-500 group-hover:bg-[#D4AF37] group-hover:text-black">
              <p.icon size={19} strokeWidth={1.5} />
            </span>
            <p className="font-display text-sm font-light leading-snug text-[#E8E3D8]">{p.label}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
